import axios from 'lib/axios'

export const getResumeStateApi = async (quoteUUID) => {
  return await axios.get(`/insurance/quotes/${quoteUUID}/resume_state`)
}
